import { useTranslation } from 'react-i18next';
import { ICON } from './icon';
import Collapse from '../Collapse';
import { Form, Input, Select, Switch } from 'antd';
import DataSubjectType from './DataSubjectType';
import { useState } from 'react';
import PolicyService from '../../../../services/Policy.service';
import { useEffect } from 'react';
import GlobalService from '../../../../services/Global.service';
import { useDsRequestContext } from '../../context';
import { useMemo } from 'react';
import EditorPrivacy from '../../../../components/Shared/forms/EditorPrivacy';
import Disclaimer from './Disclaimer';
import Confirmation from './Confirmation';

const CustomizeForm = ({ initialValue, form }) => {
    const { t, i18n } = useTranslation();

    const UIContext = useDsRequestContext();
    const UIProps = useMemo(() => {
        return {
            companyId: UIContext.companyId,
            setDsType: UIContext.setDsType,
        };
    }, [UIContext]);

    const dataSubjectType = form.getFieldValue([
        'customizeForm',
        'dataSubjectType',
    ]);

    const detailsOfClaim = form.getFieldValue([
        'customizeForm',
        'detailsOfClaim',
    ]);

    const certificateTh = form.getFieldValue([
        'customizeForm',
        'certificate',
        'certificateTh',
    ]);

    const disclaimerTh = form.getFieldValue([
        'customizeForm',
        'disclaimer',
        'disclaimerTh',
    ]);

    const allFalse = Object.values(detailsOfClaim).every(
        (value) => value === false
    );

    const [customUrl, setCustomUrl] = useState(false);
    const [privacyList, setPrivacyList] = useState([]);
    const [dsType, setDsType] = useState([]);
    const [errorDs, setErrorDs] = useState(false);

    useEffect(() => {
        if (dataSubjectType && dataSubjectType?.length === 0) {
            setErrorDs(true);
        } else {
            setErrorDs(false);
        }
    }, [dataSubjectType]);

    useEffect(() => {
        if (
            initialValue?.isUsedInventory &&
            initialValue?.customizeForm?.policyAndTermsOfService
                ?.privacyPolicyUrlId &&
            initialValue?.customizeForm?.policyAndTermsOfService
                .privacyPolicyUrl == null
        ) {
            setCustomUrl(true);
        }
    }, [initialValue]);

    useEffect(() => {
        const params = {
            dataSubjectTypeIds: '',
            status: 'Published',
        };
        const getPolicyList = async () => {
            const { data } = await PolicyService.getPolicyList(params);
            if (data.resultData) {
                setPrivacyList(data.resultData);
            }
        };
        getPolicyList();
    }, []);

    const getDs = async () => {
        const { data } = await GlobalService.getDs();
        if (data.resultData) {
            setDsType(data.resultData?.dataSubjectType);
            UIProps.setDsType(data.resultData?.dataSubjectType);
        }
    };

    useEffect(() => {
        getDs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize form')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Collapse icon={ICON.ONE} title={t('Display')}>
                    <div className="font-semibold text-xs">
                        {t('DSForm.PreliminaryInformation')}
                    </div>
                    <div className="text-[#65707A] text-xs my-4 space-y-4">
                        <div className="flex items-center justify-between">
                            <div>{t('Address')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'address']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('Phone')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'phone']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('StaffId')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'staffId']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('CardId')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'cardId']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('OtherDetail')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'detail']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="font-semibold text-xs">{t('Topic')}</div>
                    <div className="text-[#65707A] text-xs my-4 space-y-4">
                        <div className="flex items-center justify-between">
                            <div>
                                {t('Where personal information is found')}
                            </div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'display',
                                    'personalLocation',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('Supporting Evidence')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={['customizeForm', 'display', 'evidence']}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    </div>
                </Collapse>
                <Collapse
                    error={allFalse}
                    icon={ICON.TWO}
                    title={t('Type of request')}
                >
                    <div className="space-y-4">
                        <div className="font-semibold text-xs">
                            {t('detailsOfClaim')}
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToBeInform')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightInform',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToRectification')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightRectification',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToWithdrawConsent')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightWithdraw',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToBeRestrictProcessing')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightRestriction',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToBeAccess')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightAccess',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToDataPortability')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightPortability',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToObject')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightObject',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToErasure')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightErasure',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>{t('DSForm.RightToComplaint')}</div>
                            <Form.Item
                                valuePropName="checked"
                                noStyle
                                name={[
                                    'customizeForm',
                                    'detailsOfClaim',
                                    'isRightAppeal',
                                ]}
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    </div>
                </Collapse>
                <Collapse
                    defaultOpen
                    error={errorDs}
                    icon={ICON.THREE}
                    title={t('Type of data subject')}
                >
                    <DataSubjectType
                        domainId={initialValue?.domainId}
                        dsType={dsType}
                        getDs={getDs}
                        isUsedInventory={initialValue?.isUsedInventory}
                    />
                </Collapse>
                <Collapse
                    icon={ICON.FOUR}
                    title={t('Policy and Terms of Service')}
                >
                    <div
                        hidden={!initialValue?.isUsedInventory}
                        className="flex justify-between items-center mb-2"
                    >
                        <div className="text-xs text-[#65707A]">
                            {t('Use a custom URL')}
                        </div>
                        <Switch
                            defaultChecked={customUrl}
                            value={customUrl}
                            onChange={(checked) => {
                                setCustomUrl(checked);
                                if (!checked)
                                    form.setFieldValue(
                                        [
                                            'customizeForm',
                                            'policyAndTermsOfService',
                                            'privacyPolicyUrlId',
                                        ],
                                        null
                                    );
                            }}
                        />
                    </div>
                    {customUrl ? (
                        <Form.Item
                            label={
                                <div className="font-semibold text-sm">
                                    {t('Privacy Policy URL')}
                                </div>
                            }
                            name={[
                                'customizeForm',
                                'policyAndTermsOfService',
                                'privacyPolicyUrlId',
                            ]}
                        >
                            <Select
                                style={{ width: '100%' }}
                                size="large"
                                placeholder={t('Select Url')}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {privacyList?.map((privacy) => (
                                    <Select.Option
                                        key={privacy.privacyPolicyNoticeId}
                                        value={privacy.privacyPolicyNoticeId}
                                    >
                                        {i18n.language === 'en'
                                            ? privacy.privacyPolicyNoticeNameEn
                                            : privacy.privacyPolicyNoticeNameTh ??
                                              '-'}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (
                        <Form.Item
                            label={
                                <div className="font-semibold text-sm">
                                    {t('Privacy Policy URL')}
                                </div>
                            }
                            name={[
                                'customizeForm',
                                'policyAndTermsOfService',
                                'privacyPolicyUrl',
                            ]}
                        >
                            <Input
                                placeholder={t('PrivacyPlaceholder')}
                                size="large"
                            />
                        </Form.Item>
                    )}
                    <Form.Item
                        label={
                            <div className="font-semibold text-sm">
                                {t('Term Condition URL')}
                            </div>
                        }
                        name={[
                            'customizeForm',
                            'policyAndTermsOfService',
                            'termConditionUrl',
                        ]}
                    >
                        <Input
                            placeholder={t('PrivacyPlaceholder')}
                            size="large"
                        />
                    </Form.Item>
                </Collapse>
                <Collapse
                    error={!disclaimerTh}
                    icon={ICON.Disclaimer}
                    title={t('Disclaimer')}
                >
                    <Disclaimer formMain={form} />
                    <Form.Item
                        name={['customizeForm', 'disclaimer', 'disclaimerTh']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('Thai')}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <EditorPrivacy
                            readOnly
                            editorClassName="h-64"
                            hideToolbar
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item
                        name={['customizeForm', 'disclaimer', 'disclaimerEn']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('English')}
                            </span>
                        }
                    >
                        <EditorPrivacy
                            readOnly
                            editorClassName="h-64"
                            hideToolbar
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </Collapse>
                <Collapse
                    error={!certificateTh}
                    icon={ICON.FIVE}
                    title={t('Certificate')}
                >
                    <Confirmation formMain={form} />
                    <Form.Item
                        name={['customizeForm', 'certificate', 'certificateTh']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('Thai')}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <EditorPrivacy
                            readOnly
                            editorClassName="h-64"
                            hideToolbar
                            placeholder={t('COOKIE.SpecifyInformationTH')}
                        />
                    </Form.Item>
                    <Form.Item
                        name={['customizeForm', 'certificate', 'certificateEn']}
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('English')}
                            </span>
                        }
                    >
                        <EditorPrivacy
                            readOnly
                            editorClassName="h-64"
                            hideToolbar
                            placeholder={t('COOKIE.SpecifyInformationEN')}
                        />
                    </Form.Item>
                </Collapse>
            </div>
        </div>
    );
};

export default CustomizeForm;
